import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Breadcrumb } from 'react-bootstrap'
import Collapsible from '../collapsible'
import ReactS3Uploader from 'react-s3-uploader'
import Dropdown from '../dropdown'
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormGroup,
  FormControl
} from 'react-bootstrap'

@observer(['users', 'partners', 'industries', 'companystates', 'billingstatuses', 'sources', 'globals'])
export default class Imports extends Component {

  constructor(props) {
    super(props)

    this.state = {
      organizationId: this.props.globals.loggedInUser.organizationId,
      userId: 0,
      partnerId: 0,
      categoryId: 0,
      companyStateId: 0,
      billingstatusId: 0,
      sourceId: 0
    }

    this.props.users.loadAllOrganizationUsers(this.props.globals.loggedInUser.organizationId)
    this.props.partners.loadAllOrganizationPartners(this.props.globals.loggedInUser.organizationId)
    this.props.industries.loadAllIndustriesWithCategories()
    this.props.companystates.loadAllCompanyStates()
    this.props.billingstatuses.loadAllBillingStatuses()
    this.props.sources.loadAllSources()
  }

  onUserTypeChanged(e) {
    this.setState({
      userId: e.target.value
    })
  }

  onPartnerTypeChanged(e) {
    this.setState({
      partnerTypeId: e.target.value
    })
  }

  onCategoryTypeChanged(e) {
    this.setState({
      categoryId: e.target.value
    })
  }

  onCompanyStateTypeChanged(e) {
    this.setState({
      companyStateId: e.target.value
    })
  }

  onBillingStatusesTypeChanged(e) {
    this.setState({
      billingstatusId: e.target.value
    })
  }

  onSourcesTypeChanged(e) {
    this.setState({
      sourceId: e.target.value
    })
  }

  importCompanyFile(e) {

  }

  render() {
    const categoriesDropdown = this.props.industries.data ?
    (
      <FormControl componentClass="select" id="categoryId" onChange={ this.onCategoryTypeChanged.bind(this) }>
        {
          this.props.industries.data.map((ind) => {
            return (
              <optgroup label={ ind.name }>
              {
                ind.categories ? ind.categories.map((cat) => {
                  return (<option value={ cat.id }>{ cat.name }</option>)
                }) : (<option>LOADING...</option>)
              }
              </optgroup>
            )
          })
        }
      </FormControl>
    ) : (
      <div>Loading...</div>
    )

    const importInput = (
      <div>
        <h2>New Company Import</h2>
        <Form horizontal name="newCompanyImportForm">
        <FormGroup>
          <Col sm={ 2 } componentClass={ ControlLabel }>Assigned User:</Col>
          <Col sm={ 4 }><Dropdown data={ this.props.users.all } id="userId" onChange={ this.onUserTypeChanged.bind(this) } /></Col>
        </FormGroup>
        <FormGroup>
          <Col sm={ 2 } componentClass={ ControlLabel }>Partner:</Col>
          <Col sm={ 4 }><Dropdown data={ this.props.partners.data } id="partnerId" onChange={ this.onPartnerTypeChanged.bind(this) } /></Col>
        </FormGroup>
        <FormGroup>
          <Col sm={ 2 } componentClass={ ControlLabel }>Category:</Col>
          <Col sm={ 4 }>{ categoriesDropdown }</Col>
        </FormGroup>
        <FormGroup>
          <Col sm={ 2 } componentClass={ ControlLabel }>Company State:</Col>
          <Col sm={ 4 }><Dropdown data={ this.props.companystates.data } id="companyStateId" onChange={ this.onCompanyStateTypeChanged.bind(this) } /></Col>
        </FormGroup>
        <FormGroup>
          <Col sm={ 2 } componentClass={ ControlLabel }>Billing Status:</Col>
          <Col sm={ 4 }><Dropdown data={ this.props.billingstatuses.data } id="billingstatusId" onChange={ this.onBillingStatusesTypeChanged.bind(this) } /></Col>
        </FormGroup>
        <FormGroup>
          <Col sm={ 2 } componentClass={ ControlLabel }>Source:</Col>
          <Col sm={ 4 }><Dropdown data={ this.props.sources.data } id="sourceId" onChange={ this.onSourcesTypeChanged.bind(this) } /></Col>
        </FormGroup>
        <FormGroup>
          <Col sm={ 2 } componentClass={ ControlLabel }>Import File:</Col>
          <Col sm={ 4 }>
            <ReactS3Uploader
              signingUrl="/s3/sign"
              signingUrlMethod="GET"
              accept="text/csv"
              onProgress={this.onUploadProgress}
              onError={this.onUploadError}
              onFinish={this.onUploadFinish}
              signingUrlWithCredentials={ true }      // in case when need to pass authentication credentials via CORS
              uploadRequestHeaders={{ 'x-amz-acl': 'public-read' }}  // this is the default
              contentDisposition="auto"
              scrubFilename={(filename) => filename.replace(/[^\w\d_\-.]+/ig, '')}
            />
          </Col>
        </FormGroup>
        </Form>
        <Button bsStyle="success" onClick={ this.importCompanyFile.bind(this) }>Import</Button>
      </div>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Imports</Breadcrumb.Item>
            </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Imports" content={ importInput } />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/imports.js